import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useGetOne } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { ProviderShowDialogSkeleton } from 'shared/widgets/ProviderShowDialog/ProviderShowDialogSkeleton';
import { ProviderShowTable } from 'shared/widgets/ProviderShowTable/ProviderShowTable';
import { Provider } from 'types/embedded/provider';

import { StyledBox } from './ProviderShowDialog.styled';

export type ProviderShowDialogProps = {
  provider?: Partial<Provider>;
  onClose: () => void;
} & DialogProps;

export const ProviderShowDialog = ({ open, provider, onClose }: ProviderShowDialogProps) => {
  const { data, isLoading } = useGetOne(
    Resources.Providers,
    { id: provider?.['@id'] },
    { enabled: !!provider?.['@id'] },
  );
  const translate = useTypedTranslate();

  return (
    <Dialog maxWidth="md" onClose={onClose} open={open}>
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.provider.providerView')}
          titleSize="smallBold"
        />
        <Box m={3}>
          {!isLoading ? (
            <RecordContextProvider value={data}>
              <ProviderShowTable sourceId="originId" />
            </RecordContextProvider>
          ) : (
            <ProviderShowDialogSkeleton />
          )}
        </Box>
      </StyledBox>
    </Dialog>
  );
};
